module.exports = __webpack_public_path__ + "json/buildings-10.json?f2681c287347b899e595acae9ff4c042";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-10.json
// module id = 1716
// module chunks = 3